import storageUtils from '../../utils/localStorage';

const TOKEN_STORED_KEY = 'TOKEN';

const getLocalToken = () => storageUtils.getItem(TOKEN_STORED_KEY, '');

export default getLocalToken;
